export default "__VITE_ASSET__fb388a00__"